module.exports = __webpack_public_path__ + "static/media/file-upload-ic.2ac54be7.svg";